import React, { Component } from 'react'
import _ from 'lodash'
import { ReactComponent as OopsCloud } from 'ui-components/src/images/monochrome-icons/oops-cloud.svg';
import AppHeader from 'components/AppHeader'
import './Misc.scss'
import queryString from "query-string";

const extractUrlRegex1 = /Callback URL mismatch. (.+) is not in the list of allowed callback URLs: (.+)/;
const extractUrlRegex2 = /Callback URL mismatch. (.+) is not in the list of allowed callback URLs/;

const isChild = window.top !== window;

export default class extends Component {
    constructor(props){
        super(props);
        this.state = {detailedErrorOpen: false}
    }

    render(){
        const parsedParams = queryString.parse(window.location.search);
        const error = parsedParams.error;
        const errorDescription = parsedParams.error_description;
        window.ga('send', {
            hitType: 'event',
            eventCategory: 'ErrorPage',
            eventAction: error,
            eventLabel: errorDescription
        });
        if(!isChild && error === "server_error" && errorDescription === "Unable to construct sso user."){
            window.auth.logout();
            return <div/>
        }

        if (!isChild && error === "invalid_request" && _.includes(errorDescription, "unexpected SAMLP Logout response")) {
            window.auth.auth.logout();
            return <div/>
        }

        if(error && errorDescription && isChild){
            console.log("Silent callback error: ", `error=${error}&error_description=${errorDescription}`);
            window.parent.postMessage({type: "netapp:silent-authentication", hash: `error=${error}&error_description=${errorDescription}`}, "*");
            window.parent.postMessage({type: "callback_mismatch_error", hash: `error=${error}&error_description=${errorDescription}`}, "*"); //for old wrapper ( < 0.0.3)
            window.parent.postMessage({type: "auth0:silent-authentication", hash: `error=${error}&error_description=${errorDescription}`}, "*"); //for old wrapper ( < 0.0.1)
        }
        const callBackUrlFailure = error && error.includes("unauthorized_client");
        const federationNoEmailFailure = errorDescription.includes("federation_no_email");
        const federationAssociationFailure = errorDescription.includes("federation_association");

        const regex1Match = callBackUrlFailure && errorDescription.match(extractUrlRegex1);
        const regex2Match = callBackUrlFailure && !regex1Match && errorDescription.match(extractUrlRegex2);
        let attemptedCallbackUrl = null;
        let possibleCallbackUrls = null;

        if(regex1Match){
            attemptedCallbackUrl = regex1Match[1];
            possibleCallbackUrls = regex1Match[2];
        }

        if(regex2Match){
            attemptedCallbackUrl = regex2Match[1];
        }

        return (
            <div>
                <AppHeader hideWidgets={true}/>

                <div className="misc-header">
                    <OopsCloud className="cloud"/>
                    <h1>{callBackUrlFailure && "Callback URL Mismatch" }</h1>
                    <h1>{!callBackUrlFailure && !federationNoEmailFailure && "Oops! Something went wrong."}</h1>
                    <h1>{federationNoEmailFailure && "Federation User has no email address"}</h1>
                </div>

                <div className="misc-content">
                    {
                        callBackUrlFailure &&
                        <p className="err-text">The application has attempted to redirect back to <span style={{fontWeight: "bolder", color: "#003eae"}}>{attemptedCallbackUrl}</span> but this URL has not been configured as a valid redirect URL.
                            <br/><br/>Visit <a href="/cloud-managers">Cloud Central</a> to view or edit the callback addresses configured for your Cloud Managers.
                            {possibleCallbackUrls && <span>
                                You may try to connect to the application using one of the following URLs: <br/><br/>{possibleCallbackUrls.split(", ").map(url => <div><a href={url}>{url}</a></div>)}
                            </span>}
                        </p>
                    }
                    {
                        !callBackUrlFailure && !federationNoEmailFailure && !federationAssociationFailure &&
                            <p className="err-text"> You may have pressed the back button, refreshed during login, opened too many login dialogs, or there is some issue with cookies, since we couldn't find your session. Try logging in again. If the problem persists please contact NetApp Cloud Support.</p>
                    }
                    {
                        federationNoEmailFailure &&
                            <p className="err-text">You have attempted to login via federated connection, but your federation user does not have an email address or the federation server is not providing the email address with the authentication request. It is not possible to login without an email address. For more information, please contact NetApp Cloud Support.</p>
                    }
                    {
                        federationAssociationFailure &&
                        <p className="err-text">You tried to log in using a federated connection, but your federation user doesn’t match the allowed domains for this federation. Check with your federation provider or contact the NetApp cloud team for help.</p>
                    }
                    <br/><br/>
                    <hr />
                    <h2>Contact NetApp Cloud Support</h2>
                    <a href="mailto:saas.support@netapp.com">saas.support@netapp.com</a>
                    <br />
                    <br />
                    {
                        error && errorDescription &&
                        <div>
                            <button style={{fontWeight: "normal", fontSize: "12px"}} onClick={() => this.setState({detailedErrorOpen: !this.state.detailedErrorOpen})}>{this.state.detailedErrorOpen ? "Close" : "View"} detailed error message</button>
                            {
                                this.state.detailedErrorOpen &&
                                <p className="detailed-error">
                                    <span>{error}</span>:
                                    <span> {errorDescription}</span>
                                </p>
                            }
                        </div>
                    }
                </div>
            </div>);
    }
}